export default __webpack_public_path__ + "images/cn_end.png";